import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { useAppDispatch, useAppSelector } from '@/src/store/hooks'
import {
    fetchItineraryData,
    getItineraryInfo
} from '@/src/store/slices/visaSlice/itineraryInfoSlice'
import { DeviceType } from '@/src/types'

export default function useServiceRule(deviceType: DeviceType) {
    const dispatch = useAppDispatch()
    const { data, isLoading } = useAppSelector(getItineraryInfo)
    const pathname = usePathname()
    const segments = pathname.split('/')
    const itineraryId = segments[segments.length - 2]
    const { serviceRule } = data || {}

    useEffect(() => {
        if (serviceRule === undefined && itineraryId && !isLoading) {
            dispatch(fetchItineraryData({ itineraryId, deviceType }))
        }
    }, [serviceRule, itineraryId, deviceType, dispatch, isLoading])

    return { serviceRule, isLoading }
}
